import React from 'react'
import { PageHeader } from 'components'
import { useTranslation } from 'react-i18next'
import './NoMatch.css'
import { Link } from 'react-router-dom'

function NoMatch() {
  const { t } = useTranslation('common')

  // Wave 4: убрали inline-link на Bootstrap CDN (анти-паттерн, грузит UI без стилей до CDN).
  // Добавлена кнопка «На главную».
  return (
    <div>
      <section className="page_404">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 ">
              <div className="col-sm-10 col-sm-offset-1  text-center">
                <div className="four_zero_four_bg">
                  <PageHeader title="404" />
                </div>
                <div className="contant_box_404">
                  <h3 className="h2">{t('noMatch.lost')}</h3>
                  <Link to="/" className="link_404">
                    {t('noMatch.go_home', 'На главную')}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default NoMatch
